<div class="nav" [class.horizontal]="layout === 'horizontal'" [class.vertical]="layout === 'vertical'">
  <!-- Vertical Navigation Layout -->
  @if (layout === 'vertical') {
    @for (item of navigation; track item) {
      @if (checkVisibile(item)) {
        @if (item.type == 'group') {
          <fuse-nav-vertical-group [item]="item" (click)="stats(item)"></fuse-nav-vertical-group>
        }
        @if (item.type == 'collapsable') {
          <fuse-nav-vertical-collapsable
            [item]="item"
            [isVisible]="isVisibile"
            [tracker]="tracker"
            (click)="stats(item)"
          ></fuse-nav-vertical-collapsable>
        }
        @if (item.type == 'item') {
          <fuse-nav-vertical-item [item]="item" (click)="stats(item)"></fuse-nav-vertical-item>
        }
      }
    }
  }
  <!-- / Vertical Navigation Layout -->

  <!-- Horizontal Navigation Layout -->
  <!--
  <ng-container *ngIf="layout === 'horizontal'">

    <ng-container *ngFor="let item of navigation">

      <fuse-nav-horizontal-collapsable *ngIf="item.type=='group'" [item]="item"></fuse-nav-horizontal-collapsable>
      <fuse-nav-horizontal-collapsable *ngIf="item.type=='collapse'"
      [item]="item"></fuse-nav-horizontal-collapsable>
      <fuse-nav-horizontal-item *ngIf="item.type=='item'" [item]="item"></fuse-nav-horizontal-item>

    </ng-container>

  </ng-container>
  -->
  <!-- / Horizontal Navigation Layout -->
</div>
